<template>
  <ValidationObserver ref="formObserver" tag="form" novalidate>
    <div v-if="isRequisitionAnalysisPending" class="row">
      <div
        class="col-12 px-0 mb-3 border-left"
        v-for="item in documentList"
        :key="item.documentTypeId"
      >
        <div class="row bg-secondary-3 p-4">
          <div class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column ">
            <span class="mb-2 document-title">
              Tipo de Documento:
            </span>
            <span class="document-description">
              {{ item.documentTitle }}
            </span>
          </div>
          <div class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column">
            <span class="mb-2 document-title">
              Archivo:
            </span>
            <span class="document-description">
              {{ minuteFileName }}
            </span>
          </div>
          <div class="col-sm text-right">
            <action-button
              v-if="minuteFileName != '' && minuteFileName != null"
              type="button"
              text="Descargar"
              i="fa fa-file-download pl-2"
              variant="success"
              class="ml-2 px-4 mb-3 actionButton"
              @click="$emit('on-download-minute')"
            />
          </div>
        </div>
      </div>
      <div class="col-12 px-0 mb-3 border-left">
        <div class="row bg-secondary-3 p-4">
          <div class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column ">
            <span class="mb-2 document-title">
              Tipo de Documento:
            </span>
            <span class="document-description">
              PEI Firmado
            </span>
          </div>
          <div class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column">
            <span class="mb-2 document-title">
              Archivo:
            </span>
            <span v-if="hasSignedPei" class="document-description">
              PEI.pdf
            </span>
          </div>
          <div class="col-sm text-right">
            <action-button
              v-if="hasSignedPei"
              type="button"
              text="Descargar"
              i="fa fa-file-download pl-2"
              variant="success"
              class="ml-2 px-4 mb-3 actionButton"
              @click="getSignedPeiDocument()"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row bg-secondary-3 p-2 px-1 board-radius mb-3">
      <div class="col-12 p-0 py-1 rounded" :class="backgroundClass">
        <div class="col-12 tag-badge d-flex align-items-center pr-2 pl-4">
          <span class="dot text-center pl-1">
            <i class="orange-icon orange-icon-badge-align fas fa-file-alt" />
          </span>
          <span class="py-1 pl-2 font-weight-bold mb-0">
            {{ readonly ? 'Documentos' : title }}
          </span>
        </div>

        <div class="row mx-0 mt-4 px-2 col-12">
          <div class="col-12 col-md-12 mx-0 pl-4 mb-3">
            <div
              v-for="(item, index) in documentList"
              :key="item.documentTypeId"
              class="row bg-white p-3"
              :class="index < documents.length - 1 ? 'mb-3' : ''"
            >
              <div class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column">
                <span class="mb-2 document-title">
                  Tipo de Documento:
                </span>
                <span class="document-description">
                  {{ item.documentTitle }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column mt-3 mt-md-0"
              >
                <span class="mb-1 document-label document-title">
                  Archivo:
                </span>
                <div v-if="item.disabled" class="row">
                  <div class="col-sm d-flex align-items-center">
                    <span class="file-name text-underline">
                      {{ item?.document?.filename }}
                    </span>
                  </div>
                  <div class="col-sm">
                    <action-button
                      type="button"
                      i="fa fa-file-download pl-2"
                      variant="outline-success"
                      class="px-1 mr-2 actions"
                      @click="downloadDocument(item.document)"
                    />
                    <action-button
                      v-if="item.canDelete"
                      type="button"
                      i="fa fa-times-circle pl-2"
                      variant="outline-danger"
                      class="px-1 actions"
                      @click="deleteDocument(item)"
                    />
                  </div>
                </div>
                <div v-else-if="hasMinuteFileUploaded" class="row">
                  <div class="col-sm d-flex align-items-center">
                    <span class="file-name text-underline">
                      {{ minuteFileName }}
                    </span>
                  </div>
                  <div class="col-sm">
                    <action-button
                      type="button"
                      i="fa fa-file-download pl-2"
                      variant="outline-success"
                      class="px-1 mr-2 actions"
                      @click="downloadATServiceRequest()"
                    />
                    <action-button
                      v-if="item.canDelete"
                      type="button"
                      i="fa fa-times-circle pl-2"
                      variant="outline-danger"
                      class="px-1 actions"
                      @click="deleteDocument(item)"
                    />
                  </div>
                </div>
                <validation-provider
                  v-else
                  v-slot="{ errors }"
                  :rules="item.required ? 'required' : ''"
                >
                  <custom-file-input
                    ref="fileUpload"
                    v-model="item.document"
                    display-style="normal"
                    :on-download="downloadFile"
                    :accept="'.pdf'"
                    :disabled="item.disabled"
                    label-position="left"
                    :error="errors[0]"
                    custom-error-msg="El documento es requerido."
                  />
                </validation-provider>
              </div>
            </div>
            <div v-if="isSignedPending" class="row mt-4 bg-white p-3">
              <div class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column">
                <span class="mb-2 document-title">
                  Tipo de Documento:
                </span>
                <span class="document-description">
                  PEI Firmado
                </span>
              </div>
              <div
                class="col-12 col-md-8 pl-0 pl-md-2 d-flex flex-column mt-3 mt-md-0"
              >
                <div v-if="hasSignedPei" class="row">
                  <div class="col-sm d-flex align-items-center">
                    <span class="file-name text-underline">
                      PEI.pdf
                    </span>
                  </div>
                  <div class="col-s,">
                    <action-button
                      type="button"
                      i="fa fa-file-download pl-2"
                      variant="outline-success"
                      class="px-1 mr-2 actions"
                      @click="getSignedPeiDocument()"
                    />
                  </div>
                </div>
                <div v-else>
                  <div class="col-12 px-1 pr-3">
                    <WarningBox
                      title="Para obtener el documento de PEI firmado debe dirigirse a la enmienda de PEI creada en estatus completado para llevarlo a Firmado"
                    >
                      <a class="link" @click="goToStudentPeiHistory">
                        . Ir al PEI.
                      </a>
                    </WarningBox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!readonly"
            class="col-md-12 mt-3 mt-md-0 col-12 d-flex justify-content-end align-items-center px-0"
          >
            <action-button
              type="button"
              text="Cancelar"
              i="fa fa-times-circle"
              variant="outline-danger"
              class="ml-2 px-4 mb-3 actionButton"
              @click="hideDocuments()"
            />

            <action-button
              type="button"
              text="Guardar"
              i="fas fa-save"
              variant="success"
              class="ml-2 px-4 mb-3 actionButton"
              @click="saveDocuments()"
            />
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import CustomFileInput from 'CustomFileInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import DocumentsService from '@/services/documents';
import WarningBox from '@/components/pei/service/components/ServiceWarningBox';
import generalService from '@/services/pei/general';
import mixAlert from '@/mixin/alert.mixin';
import studentService from '@/services/student';
const equipmentDocumentTypes = {
  MINUTADISCUSIONEVALUACION: 16,
  ESTIPULACION80: 18,
  MINUTA: 19,
};

export default {
  name: 'AttachDiscussionDocument',
  mixins: [mixAlert],
  components: {
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    WarningBox,
  },
  props: {
    backgroundClass: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => 'Añadir Documento',
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    studentSie: {
      type: Number,
      default: () => null,
    },
    peiAtServiceId: {
      type: Number,
      default: () => null,
    },
    isSignedPending: {
      type: Boolean,
      default: () => false,
    },
    isRequisitionAnalysisPending: {
      type: Boolean,
      default: () => false,
    },
    minuteFileName: {
      type: String,
      default: () => null,
    },
    documents: {
      type: Array,
      default: () => [
        {
          documentTypeId: equipmentDocumentTypes.MINUTADISCUSIONEVALUACION,
          documentTitle: 'Minuta de Discusión de Evaluación de AT Firmada',
          document: null,
          required: true,
          disabled: false,
          canDelete: true,
        },
      ],
    },
  },
  watch: {
    peiAtServiceId: {
      immediate: true,
      handler: function(value) {
        if (value != null && this.isSignedPending) {
          this.validatePeiSigned(value).then(() => {});
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      signedPeiDocumentId: null,
      student: null,
      defaultDocumentToUpload: {
        documentTypeId: equipmentDocumentTypes.MINUTADISCUSIONEVALUACION,
        documentTitle: 'Minuta de Discusión de Evaluación de AT Firmada',
        document: null,
        required: true,
        disabled: false,
        canDelete: true,
      },
    };
  },
  computed: {
    documentList() {
      return this.documents?.length
        ? this.documents
        : [this.defaultDocumentToUpload];
    },
    hasMinuteFileUploaded() {
      return this.minuteFileName?.length > 0;
    },
    hasSignedPei() {
      return (
        this.signedPeiDocumentId !== null &&
        this.signedPeiDocumentId != '' &&
        this.signedPeiDocumentId != undefined
      );
    },
  },
  methods: {
    downloadATServiceRequest() {
      this.$emit('downloadAtDocument');
    },
    downloadFile() {},
    downloadDocument(document) {
      DocumentsService.Download(document);
    },
    hideDocuments() {
      this.$emit('on-cancel-add-document');
    },
    async saveDocuments() {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        return;
      }
      if (this.isSignedPending) {
        if (!this.hasSignedPei) {
          this.ShowToast(
            '',
            'El referido debe contar con PEI firmado.',
            'error'
          );
          return;
        }
      }
      this.$emit('on-save-document', this.documentList);
    },
    deleteDocument(item) {
      this.$emit('on-delete-document', item.documentTypeId);
    },
    async validatePeiSigned() {
      var that = this;
      var { data } = await generalService.getAtLastSignedPeiDocument(
        that.peiAtServiceId
      );
      that.signedPeiDocumentId = data;
    },
    getSignedPeiDocument() {
      DocumentsService.downloadFromServer(this.signedPeiDocumentId);
    },
    async goToStudentPeiHistory() {
      await this.$store.dispatch('$_student/setStudentDetails', {
        student: this.student,
        studentId: this.student.studentId,
        viewStudentInfo: true,
        selectThisStudent: true,
      });
      this.$store.commit('$_student/showStudentBox', true);
      this.$router.push({
        name: 'studentHistory',
      });
    },
    async getStudent() {
      const { data: response } = await studentService.getBySie(
        this.studentSie,
        false
      );
      this.student = response;
    },
  },
  async mounted() {
    await this.validatePeiSigned();
    await this.getStudent();
  },
};
</script>

<style scoped>
.row {
  margin-left: 0px;
  margin-right: 0px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.document-label {
  padding-left: 15px;
}

.document-title {
  font-size: 0.875rem !important;
}
.actions {
  height: 33px;
  width: 33px;
}

::v-deep .actions > i {
  padding-left: 0px !important;
  vertical-align: text-top !important;
}

.actionButton {
  align-self: flex-end;
}

.border-left {
  border-left-color: #b5c3bc !important;
  border-left-width: 4px !important;
}
</style>
